/* Riders Parts — the mobile menu drawer: bike finder + category and brand lists.
 *
 * The theme renders the drawer itself, so this content has to be injected at
 * runtime rather than written in Liquid. That is the ONLY reason this file
 * exists as a separate script from rp-fitment.js.
 *
 * ⚠️ It used to be an inline <script> inside the section, carrying its OWN copy
 * of the bike list. Two problems, both now fixed:
 *   1. An inlined script in a header section once printed its whole source as
 *      visible text across every page of the live site.
 *   2. The copy had drifted. The drawer offered Make and Model only — no Year,
 *      no part type — and never saved the bike, so a phone shopper could not
 *      get the saved-bike strip at all and got different results from the same
 *      bike depending on which finder they happened to use.
 * All bike data and the search/save helpers now come from window.RPFitment,
 * defined in rp-fitment.js. Load that FIRST (both are deferred, so document
 * order is preserved).
 */
(function () {
  var CATEGORIES = [
    ['Deals', '/collections/deals'],
    ['Coupon Eligible', '/collections/coupon-eligible'],   // 2026-10-03: this list is hard-coded; menu edits never reach phones
    ['Helmets', '/collections/helmets'],
    ['Riding Gear', '/collections/riding-gear'],
    ['Footwear', '/collections/footwear'],
    ['Gloves', '/collections/gloves'],
    ['Protection', '/collections/protection'],
    ['Exhaust', '/collections/exhaust'],
    ['Brakes', '/collections/brakes'],
    ['Filters', '/collections/filters'],
    ['Tires', '/collections/tires'],
    ['Suspension', '/collections/suspension'],
    ['Seats', '/collections/seats'],
    ['Decals & Graphics', '/collections/decals-graphics'],
    ['Luggage & Cases', '/collections/luggage-and-cases'],
    ['Windshields & Screens', '/collections/windshields-and-screens'],
    ['Disc Guards', '/collections/disc-guards'],
    ['All Brands', '/pages/all-brands']
  ];

  var BRANDS = [
    ['Alpinestars', '/collections/alpinestars'],
    ['Akrapovič', '/collections/akrapovic'],
    ['AGV', '/collections/agv'],
    ['HJC', '/collections/hjc'],
    ['Öhlins', '/collections/ohlins'],
    ['SW-Motech', '/collections/sw-motech'],
    ['Givi', '/collections/givi'],
    ['Puig', '/collections/puig'],
    ['LeoVince', '/collections/leovince'],
    ['Acerbis', '/collections/acerbis'],
    ['Michelin', '/collections/michelin'],
    ['Pirelli', '/collections/pirelli'],
    ['Dunlop', '/collections/dunlop'],
    ['Metzeler', '/collections/metzeler'],
    ['Vance & Hines', '/collections/vance-hines']
  ];

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  /* v2 (2026-09-25): the same Type -> Year -> Make -> Model picker as the desktop panel, driven by
     RPFitment.mountPicker, so both finders read one vehicle list and land on one vehicle page. */
  function buildFinder(F) {
    var box = el('div', 'rpbike');
    box.setAttribute('data-rp-garage', '');
    box.appendChild(el('div', 'rpbike__t', 'Shop your ride'));

    var cur = F.loadBike();
    if (cur) {
      var c = el('a', 'rpbike__cur', 'Shop parts for your ' + F.label(cur) + ' ›');
      c.href = F.vehicleUrl(cur);
      box.appendChild(c);
    }
    ['type', 'year', 'make', 'model'].forEach(function (k) {
      var s = el('select');
      s.setAttribute('data-rp-g-' + k, '');
      s.setAttribute('aria-label', k.charAt(0).toUpperCase() + k.slice(1));
      box.appendChild(s);
    });
    var go = el('button', null, 'Confirm and show results');
    go.type = 'button';
    go.setAttribute('data-rp-g-go', '');
    box.appendChild(go);

    F.mountPicker(box);
    return box;
  }


  /* Manuel, 2026-09-21: "there are no help button on the nav menu for mobile
     view, and I also like the four buttons they have at the bottom". RevZilla
     pins Log In / Shop by Vehicle / Track Order / Contact Us to the bottom of
     the drawer so they are reachable without scrolling past every category. */
  var HELP = [
    ['Customer Service', '/pages/customer-service'],
    ['Contact Us', '/pages/contact'],
    ['Shipping', '/policies/shipping-policy'],
    ['Returns & Refunds', '/policies/refund-policy'],
    ['Warranty', '/pages/warranty'],
    ['FAQ', '/pages/faq'],
    ['Track My Order', '/account'],
  ];

  var ACTIONS = [
    ['Log In', '/account/login', 'M12 12a4 4 0 100-8 4 4 0 000 8zm-8 9a8 8 0 0116 0'],
    ['Shop by Vehicle', '/pages/find-parts', 'M5.5 17.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm13 0a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM15 14H9l-2-5 4-3h4l2 3'],
    ['Track Order', '/account', 'M3 7h13v8H3zM16 10h3l2 3v2h-5zM7 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm10 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z'],
    ['Contact Us', '/pages/contact', 'M4 5h16v11H7l-3 3z'],
  ];

  function actionBar() {
    var bar = el('div', 'rpacts');
    ACTIONS.forEach(function (a) {
      var link = el('a', 'rpacts__a');
      link.href = a[1];
      link.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" ' +
        'stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + a[2] + '"/></svg>';
      link.appendChild(el('span', null, a[0]));
      bar.appendChild(link);
    });
    return bar;
  }

  function linkList(heading, items, extraClass) {
    var wrap = el('div', 'rpnav' + (extraClass ? ' ' + extraClass : ''));
    wrap.appendChild(el('div', 'rpnav__h', heading));
    items.forEach(function (it) {
      var a = el('a', null, it[0]);
      a.href = it[1];
      wrap.appendChild(a);
    });
    return wrap;
  }

  /* Returns true only when there is nothing left to do. Returning true for "not
     ready yet" is what broke the first version: a missing drawer reported
     success, boot() stopped, and the finder never appeared on mobile at all.
     Keep "not ready" (false) and "done" (true) strictly apart. */
  function build() {
    var F = window.RPFitment;
    if (!F) return false;                       // rp-fitment.js has not run yet
    var drawer = document.querySelector('.menu-drawer');
    if (!drawer) return false;                  // theme has not rendered it yet
    if (drawer.querySelector('.rpbike')) return true;

    var frag = document.createDocumentFragment();
    frag.appendChild(buildFinder(F));
    frag.appendChild(linkList('Categories', CATEGORIES));
    frag.appendChild(linkList('Brands', BRANDS, 'rpnav--sep'));
    frag.appendChild(linkList('Help', HELP, 'rpnav--sep'));

    var nav = drawer.querySelector('.menu-drawer__navigation');
    if (nav) drawer.insertBefore(frag, nav); else drawer.appendChild(frag);

    /* The action bar is pinned, so it is appended to the drawer itself rather
       than inserted into the scrolling column above the navigation. */
    if (!drawer.querySelector('.rpacts')) drawer.appendChild(actionBar());

    drawer.classList.add('rpbike-on');
    return true;
  }

  /* The drawer is created lazily by the theme, so one attempt is not enough.
     Retry on a short schedule and stop as soon as it lands, rather than the old
     fixed 1s/2.5s guesses that missed on a slow connection. */
  /* Kept deliberately: this object is how the re-render bug below was found.
     build() was reporting success while the drawer stayed empty, and without a
     status readable from outside the page that is indistinguishable from the
     script never running. Costs one small object. */
  window.__rpbike = { ran: false, calls: 0, lastResult: null, error: null };

  function safeBuild() {
    window.__rpbike.calls++;
    try {
      var r = build();
      window.__rpbike.lastResult = r;
      return r;
    } catch (e) {
      window.__rpbike.error = String(e && e.stack || e).slice(0, 400);
      return true;                              // stop retrying a hard failure
    }
  }

  /* Injecting ONCE is not enough, and this is the part that actually broke it.
     The first build SUCCEEDED — returned true, no error — and the drawer was
     still empty afterwards, because the theme re-renders the drawer after
     hydration and discards anything added before that. A retry loop that stops
     on first success can never win that race; it had already "succeeded".
     So watch rather than retry: whenever the drawer has no finder in it, put
     one back. This cannot loop, because the guard checks for .rpbike first and
     our own insertion satisfies it. */
  function boot() {
    window.__rpbike.ran = true;
    safeBuild();

    var pending = false;
    new MutationObserver(function () {
      if (pending || document.querySelector('.rpbike')) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; safeBuild(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
